


























import Vue from "vue";
import Web3 from "web3";
import { setIntervalAsync, clearIntervalAsync, SetIntervalAsyncTimer } from "set-interval-async/fixed";

export default Vue.extend({
  name: "GetCurrentBlockNumber",

  data: () => ({
    isStarted: false as boolean,
    btnColor: "primary" as string,
    btnText: "Start" as string,
    blockNumber: 0 as number,
    interval: undefined as undefined | SetIntervalAsyncTimer,
    error: "" as string,
  }),
  methods: {
    async click(): Promise<void> {
      if (this.isStarted) {
        if (this.interval != null) {
          await clearIntervalAsync(this.interval);
        }
        this.isStarted = false;
        this.btnColor = "primary";
        this.btnText = "Start";
        return;
      }

      const web3 = new Web3(new Web3.providers.HttpProvider("https://bsc-dataseed1.defibit.io:443"));

      this.isStarted = true;
      this.btnColor = "secondary";
      this.btnText = "Stop";
      this.interval = setIntervalAsync(async () => {
        const currentBlockNumber = await web3.eth.getBlockNumber();
        if (currentBlockNumber > this.blockNumber) {
          this.blockNumber = currentBlockNumber;
        }
      }, 100);
    },
  },
});
